import type { CMYKColor } from "@pdfking/math"

export const CMYK = (
  cyan: number,
  magenta: number,
  yellow: number,
  black: number,
  alpha: number
): CMYKColor =>
  ({
    cyan,
    magenta,
    yellow,
    black,
    alpha,
  }) as CMYKColor
